<template>
  <div>
    <template v-for="(summary, key) in summaries">
      <div
        v-if="!categories[key].parentId"
        :class="[
          'flexRow categorySummary',
          categories[key].children && categories[key].showChildren ? 'hasChildren' : '',
        ]"
      >
        <category-details-block
          :category="categories[key]"
          :completed="summary.totalCompleted"
          :quota="summary.totalQuota"
        />
        <!-- Include daily average -->

        <static-block-row
          class="staticBlockRow"
          :completed="!categories[key].showChildren ? summary.totalCompleted : summary.completed"
          :quota="!categories[key].showChildren ? summary.totalQuota : summary.quota"
          :color="categories[key].color"
        />
      </div>
      <template v-if="categories[key].showChildren">
        <div class="flexRow subcategory" v-for="childId in Object.keys(categories[key].children || {})">
          <subcategory-details-block :categoryId="childId" />
          <static-block-row
            class="staticBlockRow"
            :completed="summaries[childId].completed"
            :quota="summaries[childId].quota"
            :color="getCategoryColor(childId)"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import StaticBlockRow from "../components/StaticBlockRow.vue";
import CategoryDetailsBlock from "../components/CategoryDetailsBlock.vue";
import SubcategoryDetailsBlock from "../components/SubcategoryDetailsBlock.vue";

import util from "../util.js";
import categoryUtil from "../categoryUtil.js";

export default {
  name: "cumulative-week-view",
  mixins: [categoryUtil.getMixin()],
  components: {
    "static-block-row": StaticBlockRow,
    "category-details-block": CategoryDetailsBlock,
    "subcategory-details-block": SubcategoryDetailsBlock,
  },
  props: {
    categories: Object,
  },
  computed: {
    week() {
      return util.getCurrentWeek();
    },
    summaries() {
      let summaries = {};

      //FIXME - There is a cleaner way to do this
      for (let categoryId in this.categories) {
        const category = this.categories[categoryId];
        const quota = categoryUtil.getWeekQuota(categoryId);
        const totalQuota = categoryUtil.getTotalWeekQuota(categoryId);
        let completed = Object.keys(category.blocks ? category.blocks : {}).length;
        let totalCompleted = categoryUtil.getCompleted(categoryId, util.getCurrentDay(), true);

        this.week.forEach(day => {
          if (day == util.getCurrentDay()) return;

          completed += category.days[day] ? category.days[day] : 0;
          totalCompleted += categoryUtil.getCompleted(categoryId, day, true);
        });

        summaries[categoryId] = {
          completed,
          totalCompleted,
          quota,
          totalQuota,
        };
      }

      return summaries;
    },
  },
};
</script>

<style scoped>
.categorySummary.hasChildren .blockRow {
  padding-bottom: 0.125rem;
}

.flexRow {
  align-items: baseline;
}

.flexRow.categorySummary {
  flex-wrap: nowrap;
}

.staticBlockRow {
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// CumulativeWeekView.vue?3126baf9